import { useFormContext } from "react-hook-form";

import { TextFieldProps } from "@mui/material";

import { FormSelectField } from "@covertree/ui";

import { occupationOptions } from "../validatorsAndTypes/homeDetailsAndConstructionForm";
import { PersonalDetailsWithExtraQuestionsForm } from "../validatorsAndTypes/personalDetailsForm";

type Props = Omit<TextFieldProps, "variant"> & {
  name?: string;
  label?: React.ReactNode;
  placeholder?: string;
};

export function OccupationTypeSelect({
  name = "occupationType",
  label = "Occupation",
  placeholder = "Select ...",
}: Props) {
  const { control } = useFormContext<PersonalDetailsWithExtraQuestionsForm>();

  return (
    <FormSelectField
      id="occupationType"
      dataTestId="occupation-type-input"
      name={name}
      label={label}
      placeholder={placeholder}
      control={control}
      options={occupationOptions}
      optional
    />
  );
}
